import React from "react";

// An answer's words, as the agent app draws them: links, mobile numbers to call, **bold** and *italic*. A table comes
// as its own visual (PilotVisual).

const urlPatternSource = "https?:\\/\\/[^\\s]+";
// 0412 345 678, +61 412 345 678, and 61412345678 as numbers are stored.
const australianMobilePatternSource =
  "\\+61\\s?4\\d{2}[\\s-]?\\d{3}[\\s-]?\\d{3}|\\b61\\s?4\\d{2}[\\s-]?\\d{3}[\\s-]?\\d{3}|04\\d{2}[\\s-]?\\d{3}[\\s-]?\\d{3}";
const emphasisPattern = /(\*\*[^*]+\*\*|\*[^*\n]+\*|_[^_\n]+_)/g;
const australianMobilePattern = new RegExp(`^(?:${australianMobilePatternSource})$`);

const toDialablePhone = (phone) => {
  const phoneNumber = (phone || "").replace(/\s/g, "");
  return phoneNumber.startsWith("61") ? `+${phoneNumber}` : phoneNumber;
};

const renderEmphasis = (text, keyBase) => {
  const nodes = [];
  let last = 0;
  let key = 0;

  for (const match of text.matchAll(emphasisPattern)) {
    const token = match[0];
    const start = match.index ?? 0;
    if (start > last) {
      nodes.push(<React.Fragment key={`${keyBase}p${key++}`}>{text.slice(last, start)}</React.Fragment>);
    }
    nodes.push(
      token.startsWith("**") ? (
        <strong key={`${keyBase}b${key++}`} className="font-semibold">
          {token.slice(2, -2)}
        </strong>
      ) : (
        <em key={`${keyBase}i${key++}`}>{token.slice(1, -1)}</em>
      ),
    );
    last = start + token.length;
  }

  if (last < text.length) {
    nodes.push(<React.Fragment key={`${keyBase}p${key++}`}>{text.slice(last)}</React.Fragment>);
  }

  return nodes;
};

export default function PilotRichText({ content, className = "" }) {
  if (!content) return null;

  const combined = new RegExp(`(${urlPatternSource})|(${australianMobilePatternSource})`, "gi");
  const parts = [];
  let last = 0;
  let key = 0;

  for (const match of content.matchAll(combined)) {
    const matched = match[0];
    const start = match.index ?? 0;
    if (start > last) {
      parts.push(...renderEmphasis(content.slice(last, start), `s${key++}-`));
    }
    const isPhone = australianMobilePattern.test(matched);
    parts.push(
      <a
        key={`link-${key++}`}
        href={isPhone ? `tel:${toDialablePhone(matched.replace(/[\s-]+/g, ""))}` : matched.replace(/[).,]+$/, "")}
        target={isPhone ? undefined : "_blank"}
        rel={isPhone ? undefined : "noopener noreferrer"}
        className="text-blue-600 underline"
      >
        {matched}
      </a>,
    );
    last = start + matched.length;
  }

  if (last < content.length) {
    parts.push(...renderEmphasis(content.slice(last), `s${key++}-`));
  }

  return <p className={`whitespace-pre-wrap text-sm leading-6 ${className}`}>{parts}</p>;
}
